export default __webpack_public_path__ + "static/media/review2.8795d807.mp4";